import React from 'react';
import { Shield, Truck, RotateCcw, Sparkles } from 'lucide-react';

const ITEMS = [
  { icon: Truck, label: 'Free Shipping', sub: 'On orders over $5,000' },
  { icon: RotateCcw, label: '30-Day Returns', sub: 'Hassle-free' },
  { icon: Shield, label: 'Secure Checkout', sub: 'SSL encrypted' },
  { icon: Sparkles, label: 'Expert Fitting', sub: 'AI-powered wizard' },
];

export default function TrustRow() {
  return (
    <div className="border-y border-gray-200 bg-gray-50" data-testid="trust-row">
      <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.label} className="flex items-center gap-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center">
                <Icon className="w-5 h-5 text-[#334155]" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">{item.label}</p>
                <p className="text-xs text-gray-500">{item.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
